import React, { Component } from 'react';
import Header from "../../../../containers/header";
import Footer from "../../../../containers/footer";
import ProudSponsors from "../../components/common/proudSponsors";
import PastEvents from "../../components/common/pastEvents";
import Shop from "../../components/common/shop";
import Preloader from '../../../../components/preloader';

export default class pwsEventRecap extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loaderCount: 0
        }
    }

    componentDidMount = () => {
        localStorage.removeItem("recapInfo");
        localStorage.removeItem("textName");
    }

    increment = () => {
        this.setState(prevState => {
            return { loaderCount: prevState.loaderCount + 1 }
        })
    }

    decrement = () => {
        this.setState(prevState => {
            return { loaderCount: prevState.loaderCount - 1 }
        })
    }

    render() {
        const { loaderCount } = this.state;
        return (
            <div>
                <Header />
                <div className="event-main">
                    <PastEvents eventTeamType="" cType="pws" filterForm={true} textName="Events" increment={this.increment} decrement={this.decrement} eventType={2} hideChkBox={false} />
                    <div className="upcomingevent_section">
                        <Shop cType="pws" />
                    </div>
                    <ProudSponsors increment={this.increment} decrement={this.decrement}/>
                </div>
                <Footer />
                <Preloader flag={loaderCount > 0 ? true : false} />
            </div>
        )
    }
}
